import * as React from 'react';
import BasicCard from '../BasicCard';
import Dummylayout from '../Dummylayout';
import AppealApprovalTable from './AppealAprrovalTable';



function AppealMain() {
    return (
        <>
           <div> <Dummylayout/></div>
        <div className='' > 
        <BasicCard>
    
      
                <AppealApprovalTable/>

            </BasicCard>
            </div>  
        </>
    )
}
export default AppealMain;